export default __webpack_public_path__ + "static/media/mission.fd10b6b9.png";